export default "__VITE_ASSET__B4mif5CL__"